module.exports = __webpack_public_path__ + "img/fig12.0679c0de.jpg";